import { useState, useEffect } from "react";

/** Delay after close before unmounting ViewLead — must exceed sheet exit animation (see sheet `--tw-duration`). */
const UNMOUNT_AFTER_CLOSE_MS = 360;

/**
 * Keeps a lead id mounted briefly after it is cleared so the right sheet can finish its exit animation.
 */
export function useLeadSheetMount(activeLeadId: string | null) {
  const [mountedLeadId, setMountedLeadId] = useState<string | null>(null);

  useEffect(() => {
    if (activeLeadId) setMountedLeadId(activeLeadId);
  }, [activeLeadId]);

  useEffect(() => {
    if (activeLeadId || !mountedLeadId) return;
    const id = window.setTimeout(
      () => setMountedLeadId(null),
      UNMOUNT_AFTER_CLOSE_MS
    );
    return () => window.clearTimeout(id);
  }, [activeLeadId, mountedLeadId]);

  return mountedLeadId;
}
